let MethodOfEnergyGeneration = /* @__PURE__ */ function(MethodOfEnergyGeneration$1) {
	MethodOfEnergyGeneration$1["AmbientLoop"] = "Ambient loop network district heating scheme";
	MethodOfEnergyGeneration$1["DistrictHeating"] = "Network district heating scheme";
	MethodOfEnergyGeneration$1["LocalHeatPumps"] = "Local heat pumps";
	return MethodOfEnergyGeneration$1;
}({});
let PowerRequirements = /* @__PURE__ */ function(PowerRequirements$1) {
	PowerRequirements$1["PLV"] = "Primary low voltage (PLV) room only";
	PowerRequirements$1["PLVandSecondary"] = "PLV + secondary low voltage room";
	PowerRequirements$1["PLVandGenerator"] = "PLV + standby generator";
	return PowerRequirements$1;
}({});
let ExtraOptionsKeys = /* @__PURE__ */ function(ExtraOptionsKeys$1) {
	ExtraOptionsKeys$1["Sprinklers"] = "Residential sprinklered";
	ExtraOptionsKeys$1["ElectricalSubstation"] = "Electrical substation";
	ExtraOptionsKeys$1["Rainwater"] = "Rainwater harvesting system";
	ExtraOptionsKeys$1["Greywater"] = "Greywater harvesting system";
	ExtraOptionsKeys$1["ExternalGenerator"] = "Generator external";
	return ExtraOptionsKeys$1;
}({});
export { ExtraOptionsKeys, MethodOfEnergyGeneration, PowerRequirements };

//# sourceMappingURL=index250.js.map